<template>
  <div>
    <div class="wrapper">
      <input type="radio" name="select" id="option-1" @click="selectedEdad('24 AÑOS O MENOS')"/>
      <input type="radio" name="select" id="option-2" @click="selectedEdad('ENTRE 24 Y 34 AÑOS')"/>
      <input type="radio" name="select" id="option-3" @click="selectedEdad('ENTRE 35 Y 44 AÑOS')"/>
      <input type="radio" name="select" id="option-4" @click="selectedEdad('ENTRE 45 Y 54 AÑOS')"/>
      <input type="radio" name="select" id="option-5" @click="selectedEdad('ENTRE 55 Y 64 AÑOS')"/>
      <input type="radio" name="select" id="option-6" @click="selectedEdad('65 Y MÁS AÑOS')"/>
      <input type="radio" name="select" id="option-7" @click="selectedEdad('24 AÑOS O MENOS,ENTRE 24 Y 34 AÑOS,ENTRE 35 Y 44 AÑOS,ENTRE 55 Y 64 AÑOS,65 Y MÁS AÑOS')"/> 
      <!-- ENTRE 45 Y 54 AÑOS, -->

      <label for="option-1" class="option option-1">
        <div class="dot"></div>
        <span>24 años o menos</span>
      </label>
      <label for="option-2" class="option option-2">
        <div class="dot"></div>
        <span>Entre 24 y 34 años</span>
      </label>
      <label for="option-3" class="option option-3">
        <div class="dot"></div>
        <span>Entre 35 y 44 años</span>
      </label>
      <label for="option-4" class="option option-4">
        <div class="dot"></div>
        <span>Entre 45 y 54 años</span>
      </label>
      <label for="option-5" class="option option-5">
        <div class="dot"></div>
        <span>Entre 55 y 64 años</span>
      </label>
      <label for="option-6" class="option option-6">
        <div class="dot"></div>
        <span>65 años y más</span>
      </label>
      <label for="option-7" class="option option-7">
        <div class="dot"></div>
        <span>Todos</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    selectedEdad: function(selected) {
      this.$store.commit("setRHEdad", selected)
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Fira Sans", sans-serif;
}
html,
body {
  display: grid;
  height: 100%;
  place-items: center;
  background: #0069d9;
  font-family: "Fira Sans", sans-serif;
}
.wrapper {
  background: #fff;
  height: 100px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
}
.wrapper .option {
  background: #e0e0e0;
  height: 50px;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  margin-right: 15px;
}

.wrapper .option .dot::before {
  position: absolute;
  content: "";
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(1.5);
  transition: all 0.3s ease;
}
input[type="radio"] {
  display: none;
}
#option-1:checked:checked ~ .option-1,
#option-2:checked:checked ~ .option-2,
#option-3:checked:checked ~ .option-3,
#option-4:checked:checked ~ .option-4,
#option-5:checked:checked ~ .option-5,
#option-6:checked:checked ~ .option-6,
#option-7:checked:checked ~ .option-7 {
  border-color: #24c6ab;
  background: #24c6ab;
}
#option-1:checked:checked ~ .option-1 .dot,
#option-2:checked:checked ~ .option-2 .dot,
#option-3:checked:checked ~ .option-3 .dot,
#option-4:checked:checked ~ .option-4 .dot,
#option-5:checked:checked ~ .option-5 .dot,
#option-6:checked:checked ~ .option-6 .dot,
#option-7:checked:checked ~ .option-7 .dot {
  background: #fff;
}
#option-1:checked:checked ~ .option-1 .dot::before,
#option-2:checked:checked ~ .option-2 .dot::before,
#option-3:checked:checked ~ .option-3 .dot::before,
#option-4:checked:checked ~ .option-4 .dot::before,
#option-5:checked:checked ~ .option-5 .dot::before,
#option-6:checked:checked ~ .option-6 .dot::before,
#option-7:checked:checked ~ .option-7 .dot::before {
  opacity: 1;
  transform: scale(1);
}

#option-1:checked:checked ~ .option-1 span,
#option-2:checked:checked ~ .option-2 span,
#option-3:checked:checked ~ .option-3 span,
#option-4:checked:checked ~ .option-4 span,
#option-5:checked:checked ~ .option-5 span,
#option-6:checked:checked ~ .option-6 span,
#option-7:checked:checked ~ .option-7 span {
  color: #fff;
}

@media screen and (max-width: 1520px) {
  .wrapper .option {
    height: 40px;
    width: 120px;
    font-size: 14px;
  }
}

@media screen and (max-width: 1000px) {
  .wrapper .option {
    height: 30px;
    width: 90px;
    font-size: 10px;
  }
}

@media screen and (max-width: 770px) {
  .wrapper .option {
    height: 30px;
    width: 80px;
    font-size: 9px;
    margin-right: 10px;
  }
}

</style>
